// Taksit Öde penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.loanInstallmentPay';

export const loanInstallmentPayGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kredi taksiti nasıl ödenir?'),
  intro: t(`${G}.intro`, 'Bu pencere seçtiğiniz tek bir kredi taksidini öder ve ödemeyi Kredi Ödemeleri listesine kaydeder. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Taksit ve ödeme formu'),
    footer: t(`${G}.regions.footer`, 'Öde'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Taksidi kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutuda kredi adı, taksit numarası, taksit tutarı ve vade tarihi görünür. Doğru taksidi açtığınızdan emin olun.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Gecikme faizi (vadesi geçmişse)'),
      text: t(`${G}.s2.text`, 'Vade geçmişse kaç gün geciktiği yazılır ve gecikme faizi eklemek isteyip istemediğiniz sorulur. "Evet" seçerseniz bankanın aldığı faiz tutarını girin; ödenecek toplam taksit + gecikme faizi olur.'),
      tips: [
        t(`${G}.s2.tip1`, '"Evet" seçtiyseniz tutar sıfırdan büyük olmalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ödeme kaynağını seçin'),
      text: t(`${G}.s3.text`, 'Kasa veya Banka seçip hesabı belirleyin; listede yalnız kredi ile aynı para birimindeki kasa ve banka hesapları çıkar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kasa / Banka: ödenecek toplam seçilen kasadan veya banka hesabından düşülür.'),
        t(`${G}.s3.tip2`, 'Tahakkuk (Elden): kasa / banka bakiyesi değişmez, taksit yalnız ödendi olarak işaretlenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Tarih ve açıklama'),
      text: t(`${G}.s4.text`, 'İşlem Tarihi varsayılan olarak bugündür; gerekirse değiştirin. Açıklama isteğe bağlıdır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Ödemeyi tamamlayın'),
      text: t(`${G}.s5.text`, '"Öde" düğmesinde ödenecek toplam yazar. Kayıttan sonra taksit "Ödendi" olur; tüm taksitler ödendiyse kredi kendiliğinden kapanır. Hatalı ödemeyi Kredi Ödemeleri sayfasından silebilirsiniz.'),
    },
  ],
});
